export const invoiceAdjustmentRoutes = {
  path: 'invoice-adjustments',
  name: 'invoice-adjustments index',
  meta: {
    label: "Invoice Adjustments"
  },
  component: () => import("@/pages/accounting/InvoiceAdjustmentIndex.vue")
}